// Only used in local development (atlaspack dev flow)

// These must stay in sync with WindowMessageType in extension-chrome/src/scripts/message-bus/windowMessages.ts
const SESSION_COOKIE_MESSAGE_TYPES = {
	REQUEST: 'GET_SESSION_COOKIE_REQUEST',
	RESPONSE: 'GET_SESSION_COOKIE_RESPONSE',
} as const;

// Helper to get the cookie (if needed elsewhere)
export function getLocalDevSessionCookie(): string | null {
	const match = document.cookie.match(/cloud.session.token.stg=([^;]+)/);
	return match ? match[1] : null;
}

export function getLocalDevSessionCookieFromExtension(): Promise<string | null> {
	const existingSessionCookie = getLocalDevSessionCookie();
	if (existingSessionCookie) {
		return Promise.resolve(existingSessionCookie);
	}

	return new Promise((resolve) => {
		const handleMessage = (event: MessageEvent): void => {
			if (event.data.type === SESSION_COOKIE_MESSAGE_TYPES.RESPONSE) {
				window.removeEventListener('message', handleMessage);
				const cookie = event.data.cookie;
				resolve(cookie);
			}
		};

		window.addEventListener('message', handleMessage);
		window.parent.postMessage({ type: SESSION_COOKIE_MESSAGE_TYPES.REQUEST }, '*');

		// Timeout after 2 seconds
		setTimeout(() => {
			window.removeEventListener('message', handleMessage);
			resolve(null);
		}, 2000);
	});
}

export async function setLocalDevSessionCookie(): Promise<void> {
	const cookie = await getLocalDevSessionCookieFromExtension();
	if (!cookie) {
		return;
	}

	try {
		const response = await fetch(`${window.location.origin}/set-session-cookie?token=${cookie}`);
		if (response.ok) {
			// eslint-disable-next-line no-console
			console.log('🍪 Cookie set via /set-session-cookie endpoint');
		} else {
			// eslint-disable-next-line no-console
			console.error('Failed to set cookie via /set-session-cookie endpoint');
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Failed to set cookie via /set-session-cookie endpoint', error);
	}
}
